import React, { useState, useEffect, useRef } from 'react';
import './testimonials.css'
import C2wButton from '../../../common/global/button';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import "swiper/css/navigation";
import { EffectCoverflow, Navigation } from 'swiper/modules';
import { HOME, SUPERX, SUPERXTESTIMONIALS } from '../../../_utils/Routes';
import { useLocation, useNavigate } from 'react-router';

function C2wSuperxTestimonials() {

    const navigate = useNavigate(null)
    const location = useLocation()
    const [activeIndex, setActiveIndex] = useState(2); // center
    const [videoFlag, setVideoFlag] = useState(false)

    const isSuperxPage = location.pathname === '/superx' || location.pathname === SUPERX;

    const testimonials = isSuperxPage ? [
        { id: 1, name: 'AppBuilders', videoId: 'Vtyhv1QFVy0', subtitle: 'Flutter 2024' },
        { id: 2, name: 'EPnchayat', videoId: 'scadJFjx_qE', subtitle: 'Flutter 2024' },
        { id: 3, name: 'EPnchayat', videoId: 'tfyGdW8K2OE', subtitle: 'Flutter 2024' },
        { id: 4, name: 'EPnchayat', videoId: 'cUqcLGke0tM', subtitle: 'Flutter 2024' },
        { id: 5, name: 'EPnchayat', videoId: 'Ni9e8wXdIKQ', subtitle: 'Flutter 2024' },
        { id: 6, name: 'EPnchayat', videoId: '3ZncLRA0diA', subtitle: 'Flutter 2024' },
        { id: 7, name: 'EPnchayat', videoId: '-dTwEDYxuwI', subtitle: 'Flutter 2024' },
        { id: 8, name: 'EPnchayat', videoId: 'AEOOc3dKvaU', subtitle: 'Flutter 2024' },
        { id: 9, name: 'EPnchayat', videoId: 'kh55vv3ocAM', subtitle: 'Flutter 2024' },
        { id: 10, name: 'EPnchayat', videoId: 'b9FDVIZzF4k', subtitle: 'Flutter 2024' },
        { id: 11, name: 'EPnchayat', videoId: 'aqXrDAytqZo', subtitle: 'Flutter 2024' },
        { id: 12, name: 'EPnchayat', videoId: 'TwzsC_UaB9M', subtitle: 'Flutter 2024' },
        { id: 13, name: 'EPnchayat', videoId: '6rKYD4W5U1Q', subtitle: 'Flutter 2024' },
        { id: 14, name: 'EPnchayat', videoId: 'bjAzSZXOAqg', subtitle: 'Flutter 2024' },
        { id: 15, name: 'EPnchayat', videoId: 'ZjE7hKmnEIk', subtitle: 'Flutter 2024' },
        { id: 16, name: 'EPnchayat', videoId: 'WVGqByaAfg4', subtitle: 'Flutter 2024' },
        { id: 17, name: 'EPnchayat', videoId: 'P-7cxOSCtRc', subtitle: 'Flutter 2024' },
        { id: 18, name: 'EPnchayat', videoId: 'ujhc5te9oAA', subtitle: 'Flutter 2024' },
        { id: 19, name: 'EPnchayat', videoId: 'cgVhS86p2LQ', subtitle: 'Flutter 2024' },
        { id: 20, name: 'EPnchayat', videoId: '34ghrHASIf0', subtitle: 'Flutter 2024' },
        { id: 21, name: 'EPnchayat', videoId: 'kFhfAZBWY2U', subtitle: 'Flutter 2024' },
        { id: 22, name: 'EPnchayat', videoId: 'af8cwe1dHfI', subtitle: 'Flutter 2024' }
    ] : [
        { id: 1, name: 'AppBuilders', videoId: 'gLOT3NZzLb8', subtitle: 'Flutter 2024' },
        { id: 2, name: 'EPnchayat', videoId: 'YZIp89cAIsc', subtitle: 'Flutter 2024' },
        { id: 3, name: 'EPnchayat', videoId: 'Drecs4K8kWU', subtitle: 'Flutter 2024' },
        { id: 4, name: 'EPnchayat', videoId: 'tfyGdW8K2OE', subtitle: 'Flutter 2024' },
        { id: 5, name: 'EPnchayat', videoId: 'cUqcLGke0tM', subtitle: 'Flutter 2024' },
        { id: 6, name: 'EPnchayat', videoId: 'Ni9e8wXdIKQ', subtitle: 'Flutter 2024' },
        { id: 7, name: 'EPnchayat', videoId: '3ZncLRA0diA', subtitle: 'Flutter 2024' },
        { id: 8, name: 'EPnchayat', videoId: '-dTwEDYxuwI', subtitle: 'Flutter 2024' },
        { id: 9, name: 'EPnchayat', videoId: 'AEOOc3dKvaU', subtitle: 'Flutter 2024' },
        { id: 10, name: 'EPnchayat', videoId: 'kh55vv3ocAM', subtitle: 'Flutter 2024' },
        { id: 11, name: 'EPnchayat', videoId: 'b9FDVIZzF4k', subtitle: 'Flutter 2024' },
        { id: 12, name: 'EPnchayat', videoId: 'aqXrDAytqZo', subtitle: 'Flutter 2024' },
        { id: 13, name: 'EPnchayat', videoId: 'TwzsC_UaB9M', subtitle: 'Flutter 2024' },
        { id: 14, name: 'EPnchayat', videoId: '6rKYD4W5U1Q', subtitle: 'Flutter 2024' },
        { id: 15, name: 'EPnchayat', videoId: 'bjAzSZXOAqg', subtitle: 'Flutter 2024' },
        { id: 16, name: 'EPnchayat', videoId: 'ZjE7hKmnEIk', subtitle: 'Flutter 2024' },
        { id: 17, name: 'EPnchayat', videoId: 'WVGqByaAfg4', subtitle: 'Flutter 2024' },
        { id: 18, name: 'EPnchayat', videoId: 'P-7cxOSCtRc', subtitle: 'Flutter 2024' },
        { id: 19, name: 'EPnchayat', videoId: 'ujhc5te9oAA', subtitle: 'Flutter 2024' },
        { id: 20, name: 'EPnchayat', videoId: 'cgVhS86p2LQ', subtitle: 'Flutter 2024' },
        { id: 21, name: 'EPnchayat', videoId: '34ghrHASIf0', subtitle: 'Flutter 2024' },
        { id: 22, name: 'EPnchayat', videoId: 'kFhfAZBWY2U', subtitle: 'Flutter 2024' },
        { id: 23, name: 'EPnchayat', videoId: 'af8cwe1dHfI', subtitle: 'Flutter 2024' }
    ]

    const videoRefs = useRef([]);

    /**
 * @function handlePlay
 * @param {number} index - The index of the selected iframe/video to be played.
 * @state videoFlag, activeIndex
 * @ref videoRefs
 * @author Vishal Lohbande
 *
 * Description:
 * - Manages playback of YouTube videos embedded via iframe.
 * - Uses the YouTube Iframe API (`postMessage`) to pause all other videos and play the selected one.
 * - Stores references to all iframes in `videoRefs`, mapped by index.
 *
 * Behavior:
 * - Toggles `videoFlag` state to trigger video UI logic (if needed).
 * - Iterates through all `videoRefs`, and pauses all videos except the one at the given `index` by sending a postMessage.
 * - Sends a `playVideo` command to the selected iframe at the given index using the YouTube Iframe API.
 * - Updates `activeIndex` state to reflect the currently playing video.
 *
 * Requirements:
 * - All iframe `src` URLs must include `enablejsapi=1` to allow postMessage control.
 *   Example: `https://www.youtube.com/embed/VIDEO_ID?enablejsapi=1`
 *
 * Usage:
 * - Ideal for use in video carousels like Swiper, where only one YouTube video should play at a time.
 * - Attach this handler to a play button or slide click event.
 */

const handlePlay = (index) => {
  setVideoFlag(!videoFlag);

  videoRefs.current.forEach((iframe, i) => {
    if (iframe && i !== index && iframe.contentWindow) {
      iframe.contentWindow.postMessage(
        JSON.stringify({
          event: "command",
          func: "pauseVideo",
          args: [],
        }),
        "*"
      );
    }
  });

  const selectedIframe = videoRefs.current[index];
  if (selectedIframe && selectedIframe.contentWindow) {
    selectedIframe.contentWindow.postMessage(
      JSON.stringify({
        event: "command",
        func: "playVideo",
        args: [],
      }),
      "*"
    );
    setActiveIndex(index);
  }
};


    /**
         * @state windowWidth
         * @hook useEffect - Window Resize Listener
         * @author Vishal Lohbande
         *
         * Description:
         * - Initializes `windowWidth` state with the current window width.
         * - Adds a resize event listener on the window to update `windowWidth` whenever the window size changes.
         *
         * Behavior:
         * - The `handleResize` function updates the `windowWidth` state with the new window width.
         * - Cleanup function removes the event listener on component unmount to prevent memory leaks.
         *
         * Usage:
         * - Useful for responsive design decisions based on the current viewport width.
         */
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);



    /**
    * @function handleActiveIndex
    * @param {Object} swiper - The Swiper instance object
    * @author Vishal Lohbande
    *
    * Description:
    * - Updates the `activeIndex` state with the current `realIndex` of the Swiper instance.
    *
    * Behavior:
    * - Extracts `realIndex` from the Swiper instance.
    * - Calls `setActiveIndex` to reflect the active slide index in component state.
    *
    * Usage:
    * - Typically used as a Swiper event handler (e.g., onSlideChange) to keep track of the currently visible slide.
    * - Useful for conditional rendering or styling based on the active Swiper slide.
    */
    const handleActiveIndex = (swiper) => {
        setActiveIndex(swiper.realIndex)
    }

const handleMouseEnter = (index) => {
  setActiveIndex(index);
  videoRefs.current.forEach((video, i) => {
    if (activeIndex !== index) {
      // Pause YouTube video
      video.contentWindow.postMessage(
        JSON.stringify({
          event: "command",
          func: "pauseVideo",
          args: [],
        }),
        "*"
      );

      // Optional: reset video by reloading iframe
      // video.src = video.src; // Uncomment if you want to reset to start
    }
  });
};


const handleSlideChange = (swiper) => {
 setActiveIndex(swiper.realIndex);
  videoRefs.current.forEach((video, i) => {
    if (activeIndex !== swiper.realIndex) {
      // Pause YouTube video
      video.contentWindow.postMessage(
        JSON.stringify({
          event: "command",
          func: "pauseVideo",
          args: [],
        }),
        "*"
      );

      // Optional: reset video by reloading iframe
      // video.src = video.src; // Uncomment if you want to reset to start
    }
  });
};


    return (
        <div className='C2wSuperxTestimonials_ctn'>
            <div className='C2wSuperxTestimonials_content_ctn'>
                {windowWidth > 768 ? <div className='C2wSuperxDomainHeading_ctn_hld'>
                    <div className='C2wSuperxDmainHeading_ctn'>
                        {'What Our '}
                        <span className='C2wSuperxHeadingSpan'>{'Students Says'}</span>
                    </div>
                </div> :

                    <div className='C2wSuperxDomainHeading_ctn_hld'>
                        <div className='C2wSuperxDmainHeading_ctn'>
                            {'What Our '}
                        </div>
                        <div className='C2wSuperxDmainHeading_ctn'>
                            <span className='C2wSuperxHeadingSpan'>{'Students Says'}</span>

                        </div>
                    </div>
                }
                {windowWidth > 768 ? (
                    <div className="coverflow-container">
                        {testimonials.slice(0, 5).map((item, index) => {
                            let scale = 0.9
                            let zIndex = 0;
                            if (index === activeIndex) {
                                scale = 1.2;
                                zIndex = 1;
                            } else if (
                                (index === activeIndex - 1 && index >= 0) ||
                                (index === activeIndex + 1 && index < testimonials.length)
                            ) {
                                scale = 1;
                                zIndex = 0;
                            }

                            return (
                                <div
                                    key={item.id}
                                    className="card"
                                    onMouseEnter={() => handleMouseEnter(index)}
                                    style={{
                                        transform: `scale(${scale})`,
                                        zIndex,
                                        left: `${18 + index * 12}%`, // adjust spacing
                                    }}
                                >
                                    <iframe
                                        src={`https://www.youtube.com/embed/${item?.videoId}?enablejsapi=1&rel=0&modestbranding=1`}
                                        ref={(el) => (videoRefs.current[index] = el)}
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                        style={{ width: '100%', height: '100%', borderRadius: '30px' }}
                                    />
                                </div>
                            );
                        })}
                    </div>
                ) : (
                    <div className='C2wTestimonialsMobileCoverflow_ctns'>
                        <Swiper
                            className='C2wTestimonialsMobileCoverflowv_swiper'
                            modules={[EffectCoverflow, Navigation]}
                              onSlideChange={(swiper) => {
    handleActiveIndex(swiper.realIndex); // update active slide 
  }}
                            effect="coverflow"
                            grabCursor={true}
                            centeredSlides={true}
                            slidesPerView={'auto'}
                            loop={true}
                            coverflowEffect={{
                                rotate: 0,
                                stretch: 0,
                                depth: 100,
                                modifier: 2.5,
                                slideShadows: true,
                            }}
                            autoplay={{
                                delay: 1000,
                                disableOnInteraction: false,
                            }}
                            navigation
                        >
                            {
                                testimonials && testimonials?.map((obj, index) => (
                                    <SwiperSlide
                                        key={obj.id || index}
                                        className='C2wTestimonialsMobileCoverflowv_swiperSlide'
                                        onClick={() => handlePlay(index)}
                                    >
                                        <div className='C2wTestimonialsMobileCoverflowv_swiperSlide_div'>
                                     
                                            <iframe
                                                ref={(el) => (videoRefs.current[index] = el)}
                                                className='C2wTestimonialsMobileCoverflowv_swiperSlide_video_div'
                                                src={`https://www.youtube.com/embed/${obj?.videoId}?enablejsapi=1&rel=0&modestbranding=1`}
                                                frameBorder="0"
                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                allowFullScreen
                                                style={{ width: '100%', height: '100%', borderRadius: '30px' }}
                                            ></iframe>
                                        </div>
                                    </SwiperSlide>
                                ))}
                        </Swiper>
                    </div>
                )}
                <C2wButton text={'Watch all videos'} flag={ location.pathname === HOME ? 1 : 2} route={SUPERXTESTIMONIALS} />
            </div>
        </div>
    );
}

export default C2wSuperxTestimonials;